<script>
	const staffRes = {
		title: '部门人员',
		rule: {
			"width": "800",
			"height": "600",
			"fApi": [],
			"rule": [{
					"type": "el-divider",
					"children": [
						"账号信息"
					]
				},
				{
					"type": "input",
					"field": "account",
					"title": "账号",
					"value": null,
					"hidden": false,
					"props": {},
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},
				{
					"type": "input",
					"field": "password",
					"title": "密码",
					"value": null,
					"hidden": false,
					"props": {
						"type": "password",
						"showPassword": false,
						"placeholder": "默认123456"
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "el-divider",
					"children": [
						"人员信息"
					]
				},
				{
					"type": "input",
					"field": "name",
					"title": "姓名",
					"value": null,
					"hidden": false,
					"props": {},
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},
				{
					"type": "input",
					"field": "nickname",
					"title": "昵称",
					"value": null,
					"hidden": false,
					"props": {},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "input",
					"field": "code",
					"title": "编号",
					"value": null,
					"hidden": false,
					"props": {},
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},
				{
					"type": "$department",
					"field": "departmentid",
					"title": "主部门",
					"value": null,
					"hidden": false,
					"props": {
						"multiple": false,
						"checkStrictly": true
					},
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},
				{
					"type": "$department",
					"field": "secondarydepartmentid",
					"title": "次部门",
					"value": null,
					"hidden": false,
					"props": {
						"multiple": true,
						"checkStrictly": true
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$postjob",
					"field": "postjob",
					"title": "岗位",
					"value": null,
					"hidden": false,
					"props": {},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$joblevel",
					"field": "joblevel",
					"title": "职务级别",
					"value": null,
					"hidden": false,
					"props": {},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$group",
					"field": "group",
					"title": "分组",
					"value": null,
					"hidden": false,
					"props": {},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$staff",
					"field": "masterid",
					"title": "师傅",
					"value": null,
					"hidden": false,
					"props": {},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$emun",
					"field": "sex",
					"title": "性别",
					"value": null,
					"hidden": false,
					"props": {
						"name": "sex"
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$datePicker",
					"field": "birth",
					"title": "生日",
					"props": {
						"type": "date",
					},
					"value": null,
					"hidden": false,
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "input",
					"field": "phone",
					"title": "手机号",
					"value": null,
					"hidden": false,
					"props": {},
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},
				{
					"type": "input",
					"field": "wxcode",
					"title": "微信号",
					"value": null,
					"hidden": false,
					"props": {},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "input",
					"field": "email",
					"title": "邮箱",
					"value": null,
					"hidden": false,
					"props": {},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$datePicker",
					"field": "entry_time",
					"title": "入职时间",
					"props": {
						"type": "date"
					},
					"value": null,
					"hidden": false,
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "el-divider",
					"children": [
						"账户信息"
					]
				},
				{
					"type": "input",
					"field": "bankcard",
					"title": "银行卡号",
					"value": null,
					"hidden": false,
					"props": {},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "input",
					"field": "bank",
					"title": "开户行",
					"value": null,
					"hidden": false,
					"props": {},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "input",
					"field": "bankaccount",
					"title": "收款人",
					"value": null,
					"hidden": false,
					"props": {},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "el-divider",
					"children": [
						"账号状态"
					]
				},
				{
					"type": "$emun",
					"field": "status",
					"title": "状态",
					"value": 3,
					"hidden": false,
					"props": {
						"name": "staffstatus"
					},
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},
				{
					"type": "$emun",
					"field": "enable",
					"title": "是否启用",
					"value": 5,
					"hidden": false,
					"props": {
						"name": "enable"
					},
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				}
			],
			"option": {
				"form": {
					"labelWidth": "80px",
					"hideRequiredAsterisk": false,
					"showMessage": false,
					"inlineMessage": false
				},
				"global": {
					"*": {
						"props": {
							"el": true,
							"size": "small",
							"disabled": false
						},
						"col": {
							"span": 10,
							"offset": 1
						}
					},
					"el-divider": {
						"wrap": {
							"show": false
						},
						"native": false,
						"col": {
							"span": 24,
							"offset": 0
						},
						"props": {
							"contentPosition": "left"
						}
					}
				},
				"submitBtn": false,
				"resetBtn": false
			}
		}
	}

	import formBase from '@_system/components/base/form.vue'
	export default {
		extends: formBase,
		name: 'staffForm',
		props: {

		},
		data() {
			return {

			}

		},

		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			init() {
				new Promise((resolve) => {
					if (this.beforeInit) {
						this.beforeInit(resolve)
					} else {
						resolve()
					}
				}).then(() => {
					let res = JSON.parse(JSON.stringify(staffRes))
					this.rule = res.rule
					if(this.controlltype==2){
						this.rule.rule.forEach((item)=>{
							if(item.field=='account'){
								item.props.disabled = true
							}
							if(item.field=='password'){
								item.hidden = true
							}
						})
					}
					if (this.extra.defaultvalue) {
						for (let i in this.extra.defaultvalue) {
							for (let j in this.rule.rule) {
								if (this.rule.rule[j].field == i) {
									this.rule.rule[j].value = this.extra.defaultvalue[i]
								}
							}
						}
					}
					this.title = res.title
					this.width = res.rule.width
					this.height = res.rule.height

					this.openwindow()
				})
			},
			// beforeSubmit(formData, next) {
			// 	if (Array.isArray(formData.departmentid)) {
			// 		formData.departmentid = formData.departmentid[formData.departmentid.length - 1]
			// 	}
			// 	let secondarydepartmentid = []
			// 	if (Array.isArray(formData.secondarydepartmentid)) {
			// 		formData.secondarydepartmentid.forEach((item) => {
			// 			if (Array.isArray(item)) {
			// 				secondarydepartmentid.push(item[item.length - 1])
			// 			} else {
			// 				secondarydepartmentid.push(item)
			// 			}
			// 		})
			// 	}
			// 	formData.secondarydepartmentid = secondarydepartmentid.join(',')
			// 	next()
			// },
			// beforeRender(res) {
			// 	if (res.secondarydepartmentid) {
			// 		let secondarydepartmentids = res.secondarydepartmentid.split(',')
			// 		let secondarydepartmentid = []
			// 		secondarydepartmentids.forEach((item) => {
			// 			secondarydepartmentid.push(parseInt(item))
			// 		})
			// 		res.secondarydepartmentid = secondarydepartmentid
			// 	}
			// },
		},
		components: {

		}
	}
</script>
